import { render, staticRenderFns } from "./wallet-list.vue?vue&type=template&id=1f2a3f0a&scoped=true&"
import script from "./wallet-list.vue?vue&type=script&lang=js&"
export * from "./wallet-list.vue?vue&type=script&lang=js&"
import style0 from "./wallet-list.vue?vue&type=style&index=0&id=1f2a3f0a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2a3f0a",
  null
  
)

export default component.exports